import { CampaignFlatRateBlock, CampaignPackagesBlock, HtmlBlock } from '@/cms/definitions/content-types';
import BuyInsuranceSettings from '../BuyInsuranceSettings';
import { exception } from '@/appinsights/logging/ApplicationInsightLog';

export class DogSettings extends BuyInsuranceSettings {
	public manyDogsContentWarning: string;
	public manyDogsTitleWarning: string;
	public dogList: Array<string> = [];
	public dogListIds: Array<string> = [];
	public dogCountlabel: string;
	public questionVaccineTxt: string;
	public questionVaccineMultiTxt: string;
	public questionHealthyTxt: string;
	public questionHealthyMultiTxt: string;
	public questionBeenUnhealthyTxt: string;
	public questionBeenUnhealthyMultiTxt: string;
	public questionVetTxt: string;
	public questionVetMultiTxt: string;
	public vaccinePopTitle: string;
	public vaccinePopContent: string;
	public healthyPopTitle_: string;
	public healthyPopContent_: string;
	public beenUnhealthyPopTitle: string;
	public beenUnhealthyPopContent: string;
	public vetPopTitle: string;
	public vetPopContent: string;

	public vaccinePopContentMulti: string;
	public healthyPopContent_Multi: string;
	public beenUnhealthyPopContentMulti: string;
	public vetPopContentMulti: string;

	public constructor(settingsBlock: HtmlBlock, campaignBlocks: Array<CampaignFlatRateBlock | CampaignPackagesBlock>) {
		super(settingsBlock, campaignBlocks);
		this.loadAccidentSettings();
	}

	/**
	 * load settings from CMS if present
	 */
	private loadAccidentSettings() {
		try {
			let setting: string;
			const settingsArr = this.settingsBlock.markup.split('$');
			settingsArr.forEach((setting_) => {
				setting = setting_.toLowerCase().trim();
				if (setting.includes('___')) {
					// ignore setting
				} else if (setting.startsWith('manydogscontentwarning=')) {
					this.manyDogsContentWarning = this.getSettingsValue(setting_);
				} else if (setting.startsWith('manydogstitlewarning=')) {
					this.manyDogsTitleWarning = this.getSettingsValue(setting_);
				} else if (setting.startsWith('doglist=')) {
					this.dogList = this.getSettingsValue(setting_).split('¤');
				} else if (setting.startsWith('doglistids=')) {
					this.dogListIds = this.getSettingsValue(setting_).split('¤');
				} else if (setting.startsWith('dogcountlabel=')) {
					this.dogCountlabel = this.getSettingsValue(setting_);
				} else if (setting.startsWith('questionvaccinetxt=')) {
					this.questionVaccineTxt = this.getSettingsValue(setting_);
				} else if (setting.startsWith('questionvaccinemultitxt=')) {
					this.questionVaccineMultiTxt = this.getSettingsValue(setting_);
				} else if (setting.startsWith('questionhealthytxt=')) {
					this.questionHealthyTxt = this.getSettingsValue(setting_);
				} else if (setting.startsWith('questionhealthymultitxt=')) {
					this.questionHealthyMultiTxt = this.getSettingsValue(setting_);
				} else if (setting.startsWith('questionbeenunhealthytxt=')) {
					this.questionBeenUnhealthyTxt = this.getSettingsValue(setting_);
				} else if (setting.startsWith('questionbeenunhealthymultitxt=')) {
					this.questionBeenUnhealthyMultiTxt = this.getSettingsValue(setting_);
				} else if (setting.startsWith('questionvettxt=')) {
					this.questionVetTxt = this.getSettingsValue(setting_);
				} else if (setting.startsWith('questionvetmultitxt=')) {
					this.questionVetMultiTxt = this.getSettingsValue(setting_);
				} else if (setting.startsWith('vaccinepoptitle=')) {
					this.vaccinePopTitle = this.getSettingsValue(setting_);
				} else if (setting.startsWith('vaccinepopcontent=')) {
					this.vaccinePopContent = this.getSettingsValue(setting_);
				} else if (setting.startsWith('healthypoptitle_=')) {
					this.healthyPopTitle_ = this.getSettingsValue(setting_);
				} else if (setting.startsWith('healthypopcontent_=')) {
					this.healthyPopContent_ = this.getSettingsValue(setting_);
				} else if (setting.startsWith('beenunhealthypoptitle=')) {
					this.beenUnhealthyPopTitle = this.getSettingsValue(setting_);
				} else if (setting.startsWith('beenunhealthypopcontent=')) {
					this.beenUnhealthyPopContent = this.getSettingsValue(setting_);
				} else if (setting.startsWith('vetpoptitle=')) {
					this.vetPopTitle = this.getSettingsValue(setting_);
				} else if (setting.startsWith('vetpopcontent=')) {
					this.vetPopContent = this.getSettingsValue(setting_);
				} else if (setting.startsWith('vaccinepopcontentmulti=')) {
					this.vaccinePopContentMulti = this.getSettingsValue(setting_);
				} else if (setting.startsWith('healthypopcontent_multi=')) {
					this.healthyPopContent_Multi = this.getSettingsValue(setting_);
				} else if (setting.startsWith('beenunhealthypopcontentmulti=')) {
					this.beenUnhealthyPopContentMulti = this.getSettingsValue(setting_);
				} else if (setting.startsWith('vetpopcontentmulti=')) {
					this.vetPopContentMulti = this.getSettingsValue(setting_);
				}
			});
		} catch (e) {
			exception(e);
		}
	}
}
